module.exports = __webpack_public_path__ + "img/google-ads.9e5addb.png";